import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import AlbumIcon from '@material-ui/icons/Album';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';

interface Props {
  backgroundColor: string;
  name: string;
  selected: boolean;
  setSelected: (value: string) => void;
}

export const SelectCircle = (props: Props) => {
  const [hovering, setHovering] = React.useState(false);

  const checkSelectedOrHovering = () => {
    if (hovering || props.selected) return true;
  };

  let circleStyle = {
    opacity: checkSelectedOrHovering() ? 1 : 0.7,
    backgroundColor: props.backgroundColor
  };

  return (
    <div
      style={circleStyle}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className='selectCircle'
      onClick={() => props.setSelected(props.name.toLowerCase())}>
      <div className='selectCircleIcon'>
        <div style={{ textAlign: 'center' }}>{props.name}</div>
        <br />
        <div style={{ textAlign: 'center' }}>
          {props.name === 'Song' && <LibraryMusicIcon style={{ fontSize: checkSelectedOrHovering() ? 30 : 30 }} />}
          {props.name === 'Artist' && <PersonIcon style={{ fontSize: checkSelectedOrHovering() ? 30 : 30 }} />}
          {props.name === 'Genre' && <AlbumIcon style={{ fontSize: checkSelectedOrHovering() ? 30 : 30 }} />}
        </div>
      </div>
    </div>
  );
};
